module.exports = __webpack_public_path__ + "static/img/zs.ad4912b5.png";